
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PopoverContent } from '@/components/ui/popover';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';

const AuthTabs = () => {
  const { t } = useTranslation();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <PopoverContent className="w-80 p-0 z-[100]">
      {showForgotPassword ? (
        <ForgotPasswordForm onBack={() => setShowForgotPassword(false)} />
      ) : (
        <Tabs defaultValue="login" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="login">{t('auth.tabs.login')}</TabsTrigger>
            <TabsTrigger value="register">{t('auth.tabs.register')}</TabsTrigger>
          </TabsList>

          <TabsContent value="login" className="p-4 pt-2">
            <LoginForm onForgotPassword={() => setShowForgotPassword(true)} />
          </TabsContent>

          <TabsContent value="register" className="p-4 pt-2">
            <RegisterForm />
          </TabsContent>
        </Tabs>
      )}
    </PopoverContent>
  );
};

export default AuthTabs;
